export const navCopy = {
  skip_to_content: "Skip to main content",
  nav_documentation: "Documentation",
  nav_documentation_short: "Docs",
  nav_download: "Download",
  nav_community: "Community",
  nav_tools: "Tools",
  nav_search_placeholder: "Search Docs",
  nav_search_aria: "Search the TypeScript site",
  nav_beta: "Search the TypeScript site",
  nav_beta_notification:
    "Note: we are testing out the new v2 site over the weekend, if we have missed something you rely on please <a>file issues on microsoft/TypeScript-Website</a>!",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "is now available",
  nav_version_between: ", ",
  nav_version_beta_prefix: "is currently in beta.",
  nav_version_rc_prefix: "has a release candidate to try.",
}
